export const formSchema = {
  title: "",
  description: "",
  duration: null,
  // interview_before: 100,
  // additional_note:null,
  // event_link: "",
  // availabilities: [],
};

export const eventDurationsConst = ["15", "30", "45", "60", "75"];
